import React, { useState, useEffect } from 'react';
import { TextField as MUITextField } from '@mui/material';
import TEXT from './text';
import { useSelector } from 'react-redux';

const AgeComponent = ({ properties, value, valueUpdaterCallback, validityUpdaterCallback }) => {
    const { options = {}, constrains = {} } = properties;
    const language = useSelector(state => state.App_Settings.language);

    const [inputValue, setInputValue] = useState(value || options.value || '');

    // Sync with parent value changes
    useEffect(() => {
        if (value !== undefined && value !== inputValue) {
            setInputValue(value);
        }
    }, [value]);

    const handleChange = (event) => {
        const newValue = event.target.value;
        const numericValue = Number(newValue);

        if (isNaN(numericValue) || numericValue < 0) {
            return;
        }

        if (constrains.max && numericValue > constrains.max) {
            return;
        }

        if (constrains.min && numericValue < constrains.min) {
            return;
        }

        setInputValue(newValue);

        // Notify parent component
        if (valueUpdaterCallback) {
            valueUpdaterCallback(numericValue);
        }

        // Update validity
        if (validityUpdaterCallback) {
            const isValid = options.required ? newValue.trim() !== '' : true;
            validityUpdaterCallback(isValid);
        }

        if (options.onChange) {
            options.onChange(numericValue);
        }
    };

    return (
        <MUITextField
            label={options.label || TEXT.Age[language]}
            variant={options.variant || 'outlined'}
            value={inputValue}
            onChange={handleChange}
            placeholder={options.placeholder || ''}
            fullWidth={options.fullWidth !== false}
            required={options.required || false}
            inputProps={{
                max: constrains.max || undefined,
                min: constrains.min || undefined,
            }}
            sx={{ width: '100%', maxWidth: '100%' }}
        />
    );
};

export default AgeComponent;
